import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityIconProps {
  icon: React.ReactNode;
  className?: string;
}

export const ActivityIcon: React.FC<ActivityIconProps> = ({
  icon,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex h-10 w-10 flex-shrink-0 items-center justify-center',
        className,
      )}
    >
      {icon}
    </div>
  );
};
